import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MapPin, Clock, ShieldCheck, ThumbsUp } from "lucide-react";
import { IMAGES } from "@/data/images";

const AREAS = ["Swansea City", "Mumbles", "Sketty", "Uplands", "Gorseinon", "Morriston", "Killay", "Gowerton", "Llansamlet", "Pontarddulais", "Bishopston", "Clydach"];
const POINTS = [
  { icon: Clock, t: "Prompt & Reliable", d: "On time, every time." },
  { icon: ShieldCheck, t: "Fully Insured", d: "Peace of mind as standard." },
  { icon: ThumbsUp, t: "Fixed Pricing", d: "£60 minimum per job." },
];

export const Swansea = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);

  return (
    <section id="coverage" ref={ref} className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28 grid lg:grid-cols-2 gap-14 items-center">
      <div className="relative">
        <motion.div style={{ y, clipPath: "polygon(0 0, 100% 0, 100% 100%, 12% 100%, 0 88%)" }} className="border-2 border-[#0A1A4A] shadow-hard overflow-hidden">
          <img src={IMAGES.swansea} alt="Mumbles Lighthouse, Swansea" className="w-full h-[460px] object-cover" />
        </motion.div>
        <div className="absolute -top-5 -right-5 bg-[#2563EB] border-2 border-[#0A1A4A] px-5 py-3 shadow-hard">
          <span className="font-mono-accent text-xs tracking-widest uppercase text-white">Based in Swansea</span>
        </div>
      </div>

      <div>
        <div className="font-mono-accent text-xs tracking-widest uppercase text-[#2563EB] mb-3">/ Coverage</div>
        <h2 className="font-display font-black text-[#0A1A4A] text-4xl sm:text-6xl tracking-tight leading-[0.95] mb-6">
          PROUDLY SERVING<br />SWANSEA & GOWER
        </h2>
        <p className="text-[#0A1A4A]/70 text-base leading-relaxed mb-8 max-w-lg">
          Local, trusted and just around the corner. We cover Swansea city and the surrounding towns and villages across the Gower peninsula.
        </p>

        <div className="flex flex-wrap gap-2 mb-10" data-testid="coverage-areas">
          {AREAS.map((a) => (
            <span key={a} className="flex items-center gap-1.5 border-2 border-[#0A1A4A] bg-white px-3 py-1.5 text-sm font-medium">
              <MapPin size={13} className="text-[#2563EB]" /> {a}
            </span>
          ))}
        </div>

        <div className="grid sm:grid-cols-3 gap-4">
          {POINTS.map((p) => (
            <div key={p.t} className="border-l-2 border-[#2563EB] pl-4">
              <p.icon className="text-[#2563EB] mb-2" size={22} />
              <div className="font-display font-extrabold uppercase text-sm text-[#0A1A4A]">{p.t}</div>
              <div className="text-xs text-[#0A1A4A]/60 mt-1">{p.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
